import React, { useState, useContext } from 'react';
import './CollapseList.scss';
import { Collapse, Tooltip, Tag, Button } from 'antd';
import { CaretDownOutlined } from '@ant-design/icons';
import { getIcon } from '../../utils/images';
import ShipmentListCardOptions from '../ShipmentList/ShipmentListCardOptions/ShipmentListCardOptions';
import Track from '../Track/Track';
import { getStateColorMap } from '../../utils/utils';
import Urgency from '../Urgency/Urgency';
import PendingNote from '../PendingNote/PendingNote';
import NowlunFormContext from '../../context/NowlunFormContext';


const { Panel } = Collapse;

const CardHeader = ({
                      shipment,
                      clickRow,
                      refetch,
                      shipmentOptionsOpened,
                      setShipmentOptionsOpened,
                      readableOnly,
                    }) => {

  const { setShowEditNowlunForm } = useContext(NowlunFormContext);

  return (
    <div className="card-header">
      <div className="info-card-section">
        <Tooltip title={shipment.shipping_line?.name}>
          <div className="logo" data-starred={shipment.star} onClick={() => clickRow(shipment)}>
            <img src={shipment.shipping_line?.icon || getIcon('logo-mini')} />
          </div>
        </Tooltip>
        {
          shipment.group?.length > 1
            ?
            <div className="ref-num-group" onClick={() => clickRow(shipment)}>
              <img src={getIcon('collapse-group-icon')} />
              <div>{shipment.group.length} Shipments</div>
            </div>
            :
            <div className="ref-num" onClick={() => clickRow(shipment)}>
              <div className="number">
                {shipment.booking_number}
              </div>
              {shipment.bl && (
                <div className="sub-number">
                  {shipment.bl}
                </div>
              )}
              {shipment.client_ref && (
                <div className="sub-number">
                  {shipment.client_ref}
                </div>
              )}
            </div>
        }
        <ShipmentListCardOptions
          shipment={shipment}
          refetch={refetch}
          shipmentOptionsOpened={shipmentOptionsOpened}
          setShipmentOptionsOpened={setShipmentOptionsOpened}
          onShowNowlunForm={setShowEditNowlunForm}
          readableOnly={readableOnly}
        />
      </div>

      <div className="track-card-section">
        {
          shipment.fetch
            ? <div><img src={getIcon('track-fetching')} /></div>
            : shipment.pol?.name
              ? <div className="track-wrapper" onClick={() => clickRow(shipment)}><Track shipment={shipment} /></div>
              : <PendingNote collapse={false} />
        }
      </div>
    </div>
  );
};

const SingleCard = ({ shipment, clickRow, tagSummary }) => {
  return (
    <div className="SingleCard">
      {
        shipment.cargo
          ?
          <div className="cargo-card-section">
            <div className="title">
              Cargo
            </div>
            {
              shipment.pol
                ? <div className="cargo" onClick={() => clickRow(shipment)}>{shipment.cargo}</div>
                : <div><img src={getIcon('cargo-fetching')} /></div>
            }
          </div>
          : <></>
      }

      {
        shipment.tags
          ?
          shipment.tags.length
            ? <div className="tags-card-section">
              <div className="status" onClick={() => clickRow(shipment)}>{tagSummary(shipment.tags, true)}</div>
            </div>
            : <></>
          : <div className="fetch-spin"><span><img src={getIcon('fetch', 'gif')} /></span><span className="text"></span>
          </div>
      }
    </div>
  );
};

const GroupCard = ({ shipment, clickRow, tagSummary }) => {
  return (
    <div className="GroupCard">
      {shipment.group.map((shipment, index) => {
        return (
          <div className="card-collection" key={index}>
            <div className="info-wrapper">
              <div className="ref-num">
                <div className="number">
                  {shipment.booking_number}
                </div>
                {shipment.bl && (
                  <div className="sub-number">
                    {shipment.bl}
                  </div>
                )}
                {shipment.client_ref && (
                  <div className="sub-number">
                    {shipment.client_ref}
                  </div>
                )}
              </div>

              <SingleCard key={index} shipment={shipment} clickRow={clickRow} tagSummary={tagSummary} />
            </div>
            <div className="action-wrapper">
              <Button className="link-btn archive-btn" onClick={() => clickRow(shipment)}>
                View
              </Button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

const CollapseList = ({
                        shipments,
                        updates,
                        selectShipment,
                        refetch,
                        tagSummary,
                        readableOnly,
                      }) => {
  const [shipmentOptionsOpened, setShipmentOptionsOpened] = useState(null);

  const clickRow = (shipment) => {
    selectShipment(shipment);
    setShipmentOptionsOpened(null);
  };

  return (
    <div className="CollapseList">
      {
        shipments.map((shipment, index) => {
          return (
            <div className="collapse-card" key={index}>
              <CardHeader
                shipment={shipment}
                clickRow={clickRow}
                refetch={refetch}
                shipmentOptionsOpened={shipmentOptionsOpened}
                setShipmentOptionsOpened={setShipmentOptionsOpened}
                readableOnly={readableOnly}
              />

              <Collapse
                ghost
                key={index}
                bordered={false}
                defaultActiveKey={['1']}
                expandIconPosition="end"
                collapsible={!shipment.cargo && !shipment.tags?.length && 'disabled'}
                expandIcon={({ isActive }) => <CaretDownOutlined rotate={isActive ? 180 : 0} />}
              >
                <Panel
                  className="state-card-section"
                  header={
                    shipment.state
                      ?
                      <div className="status">
                        <Tag className="tag"
                             color={getStateColorMap(shipment.state).color}>{getStateColorMap(shipment.state).title}</Tag>
                        <Urgency shipment={shipment} updates={updates} />
                      </div>
                      : <div><img src={getIcon('status-fetching')} /></div>
                  }
                >
                  {
                    shipment.group?.length > 1
                      ?
                      <GroupCard shipment={shipment} clickRow={clickRow} tagSummary={tagSummary} />
                      :
                      <SingleCard shipment={shipment} clickRow={clickRow} tagSummary={tagSummary} />
                  }
                </Panel>
              </Collapse>
            </div>
          );
        })
      }
    </div>
  );
};

export default CollapseList;
